import { render, staticRenderFns } from "./FixedBottomSaveButton.vue?vue&type=template&id=59fec8fa&scoped=true"
import script from "./FixedBottomSaveButton.vue?vue&type=script&lang=js"
export * from "./FixedBottomSaveButton.vue?vue&type=script&lang=js"
import style0 from "./FixedBottomSaveButton.vue?vue&type=style&index=0&id=59fec8fa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fec8fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59fec8fa')) {
      api.createRecord('59fec8fa', component.options)
    } else {
      api.reload('59fec8fa', component.options)
    }
    module.hot.accept("./FixedBottomSaveButton.vue?vue&type=template&id=59fec8fa&scoped=true", function () {
      api.rerender('59fec8fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/FixedBottomSaveButton.vue"
export default component.exports